<!-- 学生维度 -->
<template>
  <div class="student">
    <div class="container">
      <!-- 面包屑 -->
      <div class="bread">
        <span class="bread-tab">学生维度</span>
      </div>
      <!-- 内容 -->
      <div class="show-box">
        <!-- 上面表格数据 -->
        <div class="stu-data">
          <div class="stu-data-l">
            <div class="data-zcpeople">
              <span class="zcpeople-number">{{ tablelist.total || "0" }}</span>
              <span class="zcpeople-name">注册总人数</span>
            </div>
          </div>
          <div class="stu-data-r clearfix">
            <div class="data-rt">
              <div class="data-rt-search show-search">
                <div class="search-item">
                  <span class="search-label">培养层次：</span>
                  <el-select
                    class="search-form"
                    size="small"
                    clearable
                    v-model="dataForm.trainLevel"
                    placeholder="请选择培养层次"
                    @change="changeCultivateList"
                  >
                    <el-option label="未知" value="0"></el-option>
                    <el-option label="专科" value="1"></el-option>
                    <el-option label="本科" value="2"></el-option>
                    <el-option label="硕士研究生" value="3"></el-option>
                    <el-option label="博士研究生" value="4"></el-option>
                  </el-select>
                </div>
                <div class="search-item">
                  <span class="search-label">政治面貌：</span>
                  <el-select
                    class="search-form"
                    size="small"
                    clearable
                    v-model="dataForm.politicalCode"
                    placeholder="请选择政治面貌"
                    @change="changeCultivateList"
                  >
                    <el-option
                      v-for="(item, index) of cultivateList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="data-rt-table">
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{
                    tablelist.joinNum || "0"
                  }}</span>
                  <span class="rt-table-item-name">报名人数</span>
                </div>
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{
                    tablelist.passNum || "0"
                  }}</span>
                  <span class="rt-table-item-name">录取人数</span>
                </div>
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{
                    tablelist.signInNum || "0"
                  }}</span>
                  <span class="rt-table-item-name">报到人数</span>
                </div>
                <!-- <div class="rt-table-item">
                  <span class="rt-table-item-number">{{ tablelist.signInNum || '0' }}</span>
                  <span class="rt-table-item-name">年级</span>
                </div>
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{ tablelist.signInNum || '0' }}</span>
                  <span class="rt-table-item-name">姓名</span>
                </div>
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{ tablelist.signInNum || '0' }}</span>
                  <span class="rt-table-item-name">培养层次</span>
                </div>
                <div class="rt-table-item">
                  <span class="rt-table-item-number">{{ tablelist.signInNum || '0' }}</span>
                  <span class="rt-table-item-name">政治面貌</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 中间 饼图数据展示 -->
        <div class="stu-echart">
          <div ref="stuGender" class="stu-echart-item stu-gender"></div>
          <div ref="stuGrade" class="stu-echart-item stu-grade"></div>
          <div ref="stuTrainLevel" class="stu-echart-item stu-trainLevel"></div>
          <div ref="stuPolitical" class="stu-echart-item stu-political"></div>
        </div>
        <!-- 下面 地图数据 -->
        <div class="stu-map">
          <div class="map-box">
            <div ref="mymapChart" class="mymapChart"></div>
          </div>
          <div class="mapdata-box">
            <div class="map-msg" v-if="mapDatalist && mapDatalist.length > 0">
              <div
                class="map-msg-s"
                v-for="(item, index) of mapDatalist"
                :key="index"
              >
                <div class="map-msg-st">{{ item.label }}</div>
                <div class="map-msg-sb">{{ item.value }}</div>
              </div>
            </div>
            <div class="map-other-msg" v-else>暂无数据...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option, Input, Button } from "element-ui";
// eslint-disable-next-line
import china from "echarts/map/js/china";
export default {
  components: {
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    "el-button": Button
  },
  data() {
    return {
      statuslist: [],
      dataForm: {
        politicalCode: "", // 政治面貌
        trainLevel: "" // 培养层次
      },
      mapSelect: false,
      selectName: "",
      chinaDatas: [],
      mapDatalist: [],
      cultivateList: [],
      tablelist: {},
      xbBingData:[],
      njBingData:[],
      pyccBingData:[],
      zzmmBingData:[]
    };
  },
  created() {
    this.$nextTick(()=>{
      this.getCultivate();
      this.initTablelist(()=>{
        if(this.xbBingData.length > 0){
          this.xbBing()
        }
        if(this.njBingData.length > 0){
          this.njBing()
        }
        if(this.pyccBingData.length > 0){
          this.pyccBing()
        }
        if(this.zzmmBingData.length > 0){
          this.zzmmBing()
        }
      });
    })
    
  },
  mounted() {
    this.queryMap(() => {
      this.mapInit();
      // this.getMapdata()
    });
  },
  methods: {
    // 总人数获取，表格数据
    initTablelist(callback) {
      this.$http({
        method: "POST",
        url: "/joinuser/statistics",
        params: {
          politicalCode: this.dataForm.politicalCode,
          trainLevel: this.dataForm.trainLevel
        }
      })
        .then(res => {
          if (res.code === 100) {
            this.tablelist = res.result;
            // 性别数据统计
            if(res.result.gender && res.result.gender !== null){
              for(var a in res.result.gender){
                let itemA = {
                  value:res.result.gender[a],
                  name:a
                }
                this.xbBingData.push(itemA)
              }
            }
            // 年级数据统计
            if(res.result.grade && res.result.grade !== null){
              for(var a in res.result.grade){
                let itemA = {
                  value:res.result.grade[a],
                  name:a
                }
                this.njBingData.push(itemA)
              }
            }
            // 培养层次数据统计
            if(res.result.trainLevel && res.result.trainLevel !== null){
              for(var a in res.result.trainLevel){
                let itemA = {
                  value:res.result.trainLevel[a],
                  name:a
                }
                this.pyccBingData.push(itemA)
              }
            }
            // 政治面貌数据统计
            if(res.result.political && res.result.political !== null){
              for(var a in res.result.political){
                let itemA = {
                  value:res.result.political[a],
                  name:a
                }
                this.zzmmBingData.push(itemA)
              }
            }
            if(callback){
              callback()
            }
          } else {
            this.$message.error(res.msg || res.result.msg);
            return false;
          }
        })
        .catch(error => {
          console.log(error);
          return false
        })
    },
    // 培养层次/政治面貌改变事件
    changeCultivateList() {
      this.initTablelist();
    },
    // 初始化地图数据
    mapInit() {
      let _ = this;
      let myChart = this.echarts.init(this.$refs.mymapChart);
      let option = {
        backgroundColor: "transparent",
        geo: {
          map: "china",
          label: {
            emphasis: {
              color: "white",
              show: false
            }
          },
          zoom: 1.2,
          itemStyle: {
            normal: {
              borderWidth: 1, // 区域边框宽度
              borderColor: "#efefef", // 区域边框颜色
              areaColor: "#e6e6e6" // 区域颜色
            },
            emphasis: {
              areaColor: "#1da3f7"
            }
          },
          regions: this.chinaDatas,
          tooltip: {
            show: false
          }
        },
        series: [
          {
            type: "map",
            mapType: "china",
            showLegendSymbol: false,
            geoIndex: 0,
            z: 0,
            data: this.convertData(this.chinaDatas)
          }
        ]
      }
      myChart.setOption(option);
      setTimeout(() => {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: 0
        })
      }, 0)
      myChart.on("click", params => {
        if (params.seriesType === "map") {
          // 如果不存在，则不能选中
          if (_.selectName === params.name && _.mapSelect === false) {
            _.mapSelect = true
          } else if (_.selectName === params.name) {
            _.mapSelect = false
          } else if (_.mapSelect === false) {
            _.mapSelect = true
          }
          // 判断地图的请求内容，是否是选中状态,如果不是,请求全国数据;如果是,按照区域搜索
          if (_.mapSelect === true) {
            this.getMapdata(params.value);
          } else {
            this.getMapdata()
          }
          if (params.data && params.data !== undefined) {
            option.geo.regions = [
              {
                name: params.name,
                // eslint-disable-next-line
                selected: _.mapSelect
              }
            ]
            // 选中当前区域
            myChart.setOption(option);
            setTimeout(() => {
              myChart.dispatchAction({
                type: "showTip",
                seriesIndex: 0,
                dataIndex: 0
              });
            }, 0);
            _.selectName = params.name;
          }
        }
      });
    },
    // 获取培养层次数据
    getCultivate() {
      this.$http({
        method: "POST",
        url: "/common/political"
      })
        .then(res => {
          if (res.code === 100) {
            this.cultivateList = res.result;
          } else {
            this.$message.error(res.msg || res.result.msg);
            return false;
          }
        })
        .catch(error => {
          console.log(error);
          return false;
        });
    },
    // 地图数据加载
    queryMap(callback) {
      this.$http({
        method: "POST",
        url: "/common/province"
      })
        .then(res => {
          if (res.code === 100) {
            this.chinaDatas = res.result;
            callback();
          } else {
            this.$message.error(res.msg || res.result.msg);
            callback();
            return false;
          }
        })
        .catch(error => {
          console.log(error);
          callback();
          return false;
        });
    },
    // 地图按区域划分数据分类
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        res.push({
          name: data[i].label,
          value: data[i].value
        });
        // }
      }
      return res;
    },
    // 点击地图获取相应区域的数据
    getMapdata(id) {
      this.mapLoad = true;
      if (id && id !== "") {
        let params = {
          provinceId: id
        };
        this.$http({
          method: "POST",
          url: "/province/statistics",
          params: params
        })
          .then(res => {
            if (res.code === 100) {
              this.mapLoad = false;
              this.mapDatalist = res.result;
            } else {
              this.mapLoad = false;
              this.mapDatalist = [];
              this.$message.error(res.msg || res.result.msg);
              return false;
            }
          })
          .catch(error => {
            this.mapLoad = false;
            this.mapDatalist = [];
            console.log(error);
            return false;
          });
      } else {
        this.mapLoad = false;
        this.mapDatalist = [];
      }
    },
    // 性别饼图
    xbBing() {
      let _ = this;
      let xbmyChart = this.echarts.init(this.$refs.stuGender);
      let option = {
        title:{
          left:'center',
          padding: [15, 10],
          text:'性别统计',
          textStyle:{
            color:'#333333',
            fontStyle:'normal',
            fontWeight:'bold',
    　　　　 fontSize:16
          }
        },
        tooltip: {
          show:true,
          trigger: 'item',
          backgroundColor: '#555555',
          textStyle:{
              color: '#ffffff',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontFamily: 'sans-serif',
              fontSize: 14,
          },
          formatter: function(params){
              return params.name + ': ' + params.value + '人'
          }
        },
        legend: {
          top: "15%",
          orient: 'vertical',
          right: "1%",
          itemWidth: 25,   // 设置图例图形的宽
          itemHeight: 10,  // 设置图例图形的高
          itemGap: 8,
        },
        series: [
          {
            name: "性别统计",
            type: "pie",
            center: ["40%","50%"],
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.xbBingData
          }
        ]
      }
      xbmyChart.setOption(option)
    },
    // 年级饼图
    njBing(){
      let _ = this;
      let njmyChart = this.echarts.init(this.$refs.stuGrade);
      let option = {
        title:{
          left:'center',
          padding: [15, 10],
          text:'年级统计',
          textStyle:{
            color:'#333333',
            fontStyle:'normal',
            fontWeight:'bold',
    　　　　 fontSize:16
          }
        },
        tooltip: {
          show:true,
          trigger: 'item',
          backgroundColor: '#555555',
          textStyle:{
              color: '#ffffff',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontFamily: 'sans-serif',
              fontSize: 14,
          },
          formatter: function(params){
              return params.name + ': ' + params.value + '人'
          }
        },
        legend: {
          top: "15%",
          orient: 'vertical',
          right: "1%",
          itemWidth: 25,   // 设置图例图形的宽
          itemHeight: 10,  // 设置图例图形的高
          itemGap: 8,
        },
        series: [
          {
            name: "年级统计",
            type: "pie",
            center: ["40%","50%"],
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.njBingData
          }
        ]
      }
      njmyChart.setOption(option)
    },
    // 培养层次饼图
    pyccBing(){
      let _ = this;
      let pyccmyChart = this.echarts.init(this.$refs.stuTrainLevel);
      let option = {
        title:{
          left:'center',
          padding: [15, 10],
          text:'培养层次统计',
          textStyle:{
            color:'#333333',
            fontStyle:'normal',
            fontWeight:'bold',
    　　　　 fontSize:16
          }
        },
        tooltip: {
          show:true,
          trigger: 'item',
          backgroundColor: '#555555',
          textStyle:{
              color: '#ffffff',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontFamily: 'sans-serif',
              fontSize: 14,
          },
          formatter: function(params){
              return params.name + ': ' + params.value + '人'
          }
        },
        legend: {
          top: "15%",
          orient: 'vertical',
          right: "1%",
          itemWidth: 25,   // 设置图例图形的宽
          itemHeight: 10,  // 设置图例图形的高
          itemGap: 8,
        },
        series: [
          {
            name: "培养层次统计",
            type: "pie",
            center: ["40%","50%"],
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.pyccBingData
          }
        ]
      }
      pyccmyChart.setOption(option)
    },
    // 政治面貌饼图
    zzmmBing(){
      let _ = this;
      let zzmmmyChart = this.echarts.init(this.$refs.stuPolitical);
      let option = {
        title:{
          left:'center',
          padding: [15, 10],
          text:'政治面貌统计',
          textStyle:{
            color:'#333333',
            fontStyle:'normal',
            fontWeight:'bold',
    　　　　 fontSize:16
          }
        },
        tooltip: {
          show:true,
          trigger: 'item',
          backgroundColor: '#555555',
          textStyle:{
              color: '#ffffff',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontFamily: 'sans-serif',
              fontSize: 14,
          },
          formatter: function(params){
              return params.name + ': ' + params.value + '人'
          }
        },
        legend: {
          top: "15%",
          orient: 'vertical',
          right: "1%",
          itemWidth: 25,   // 设置图例图形的宽
          itemHeight: 10,  // 设置图例图形的高
          itemGap: 8,
        },
        series: [
          {
            name: "政治面貌统计",
            type: "pie",
            center: ["40%","50%"],
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: true
            },
            data: this.zzmmBingData
          }
        ]
      }
      zzmmmyChart.setOption(option)
    }
  }
};
</script>
<style src="./student.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/student/student.vue